import { render, staticRenderFns } from "./DxToolsDatabase.vue?vue&type=template&id=22630670&"
import script from "./DxToolsDatabase.vue?vue&type=script&lang=js&"
export * from "./DxToolsDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports